var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.63107 17.3095V14.7539C6.63105 14.1039 7.16099 13.5757 7.81757 13.5713H10.2226C10.8823 13.5713 11.4171 14.1008 11.4171 14.7539V14.7539V17.3175C11.417 17.8694 11.8619 18.3204 12.4193 18.3334H14.0226C15.621 18.3334 16.9167 17.0506 16.9167 15.4682V15.4682V8.19822C16.9082 7.57571 16.6129 6.99114 16.115 6.61088L10.6315 2.23777C9.67083 1.47633 8.30523 1.47633 7.34457 2.23777L1.88508 6.61882C1.38527 6.99754 1.08954 7.58308 1.08339 8.20615V15.4682C1.08339 17.0506 2.37912 18.3334 3.97748 18.3334H5.58086C6.15202 18.3334 6.61503 17.875 6.61503 17.3095V17.3095",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.f7c0c3bc82c6dced1dfc43a34944b0de.svg";
export { ForwardRef as ReactComponent };